import { ChevronLeft, RotateCcw, Trash2, X } from "lucide-react";
import {
    C,
    CRED_TYPES,
    sBtn,
    sCard,
    sFull,
    sTopBar,
    fmtDate,
} from "../styles";

export default function Trash({
    trash,
    onRestore,
    onPurge,
    onEmpty,
    onBack,
}) {
    return (
        <div style={sFull} data-testid="trash-screen">
            <div style={sTopBar}>
                <button onClick={onBack} style={iconBtn} data-testid="trash-back-btn">
                    <ChevronLeft size={16} />
                </button>
                <div
                    style={{
                        fontSize: 12,
                        color: C.muted,
                        letterSpacing: "0.1em",
                        textTransform: "uppercase",
                    }}
                >
                    Trash · {trash.length}
                </div>
                {trash.length > 0 ? (
                    <button
                        onClick={() => {
                            if (window.confirm("Permanently delete all trash?")) onEmpty();
                        }}
                        style={{
                            ...iconBtn,
                            color: C.danger,
                            borderColor: "rgba(217,43,43,0.3)",
                        }}
                        data-testid="trash-empty-btn"
                    >
                        Empty
                    </button>
                ) : (
                    <div style={{ width: 80 }} />
                )}
            </div>
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    padding: "20px",
                    maxWidth: 560,
                    margin: "0 auto",
                    width: "100%",
                }}
            >
                {trash.length === 0 && (
                    <div
                        style={{
                            textAlign: "center",
                            padding: "80px 20px",
                            color: C.dim,
                        }}
                        data-testid="trash-empty-state"
                    >
                        Trash is empty
                    </div>
                )}
                {trash.map((e) => {
                    const type = CRED_TYPES.find((t) => t.id === e.type) || CRED_TYPES[0];
                    return (
                        <div key={e.id} style={{ ...sCard, cursor: "default" }}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 10,
                                }}
                            >
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <div
                                        style={{
                                            fontSize: 14,
                                            color: C.text,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {e.fields[type.fields[0]] || "(untitled)"}
                                    </div>
                                    <div
                                        style={{
                                            fontSize: 11,
                                            color: C.dim,
                                            marginTop: 2,
                                        }}
                                    >
                                        {type.label} · deleted{" "}
                                        {fmtDate(e.deletedAt)}
                                    </div>
                                </div>
                                <div style={{ display: "flex", gap: 6 }}>
                                    <button
                                        onClick={() => onRestore(e.id)}
                                        style={smallBtn}
                                        title="Restore"
                                        data-testid="trash-restore-btn"
                                    >
                                        <RotateCcw size={13} />
                                    </button>
                                    <button
                                        onClick={() => {
                                            if (window.confirm("Permanently delete?"))
                                                onPurge(e.id);
                                        }}
                                        style={{
                                            ...smallBtn,
                                            color: C.danger,
                                            borderColor: "rgba(217,43,43,0.3)",
                                        }}
                                        title="Permanently delete"
                                        data-testid="trash-purge-btn"
                                    >
                                        <X size={13} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

const iconBtn = {
    background: "transparent",
    border: `1px solid ${C.border}`,
    borderRadius: 10,
    color: C.muted,
    padding: "7px 14px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    fontFamily: C.font,
    fontSize: 12,
};

const smallBtn = {
    background: "transparent",
    border: `1px solid ${C.border}`,
    borderRadius: 8,
    color: C.muted,
    padding: "6px 9px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
};
